import React, {useCallback, useEffect, useRef, useState} from 'react'
import {Link} from 'react-router-dom'
import {withTranslation} from 'react-i18next'

import RoutesNav from 'RoutesNavbar'
import requestHandler from 'utils/requestHandler'
import {searchService} from 'services'
import BButton from 'components/Form/Fields/BButton'
import ProductsList from 'components/ProductsList'
import getPageSize from 'utils/getPageSize'

const pageSize = getPageSize()

const SearchMain = ({t, onInteract, reset, isOpen, isSearching, setSearching}) => {
  const [data, setData] = useState({})
  const [searchValue, setSearchValue] = useState('')

  useEffect(() => {
    setTimeout(() => {
      setSearchValue('')
      setData({})
    }, 650)
  }, [reset])

  const handleSearch = useCallback(e => {
    setSearching(true)
    const searchValueTmp = e.target.value
    setSearchValue(searchValueTmp)

    if (!searchValueTmp.length) {
      setData({})
    } else if (searchValueTmp.length < 3) {
      setData({error: 'At least 3 letters'})
    } else {
      setData({loading: true})
      requestHandler(() => searchService.prosugcat(searchValueTmp, {take: pageSize}), 'json')
        .then(r => {
          if (r.success) setData(r.data)
          else setData({error: 'request error'})
        })
    }
  }, [setSearching])

  const searchField = useRef()
  const onClickSearchBtn = e => {
    if (!searchValue || searchValue.length < 3) {
      e.preventDefault()
      searchField.current.focus()
    }
  }

  return (
    <div className='searchMain'>
      <div id='searchMainField'>
        <input
          ref={searchField}
          autoComplete='off'
          onFocus={() => onInteract(true, searchValue)}
          onBlur={() => onInteract(false, searchValue)}
          placeholder={t("What are you looking for?")}
          onChange={handleSearch}
          value={searchValue}
        />

        <Link to={loc => (searchValue && searchValue.length >= 3) ? `/search/${searchValue}` : loc} onClick={onClickSearchBtn}>
          <BButton yellow>{t('SEARCH')}</BButton>
        </Link>
      </div>

      <div id='searchMain-results' className={isOpen ? 'searchMain-resultsOpen' : ''}>
        {(isSearching || !isOpen) ? (
          data.items ? (
            <ProductsList
              mode='autocomplete'
              items={data.items}
              loadMoreRequest={(page) => searchService.prosugcat(searchValue, {take: pageSize, skip: page * pageSize})}
              setData={setData}
              handleSearch={handleSearch}
              searchValue={searchValue}
            />
          ) : data.error ? (
            <p>{data.error}</p>
          ) : (
            data.loading && 'loading...'
          )
        ) : <RoutesNav data={data}/>}
      </div>
    </div>
  )
}

export default withTranslation()(SearchMain)
